import React, { useState, useEffect, useContext } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import Table from 'examples/Tables/Table';
import {
  CircularProgress, // Import CircularProgress
  Box, // Import Box
} from '@mui/material';

import { UserContext } from 'context/userContext';
import { RecentContext } from 'context/recentContext';

function RecentOrgs({ orgs, onEdit, onDelete, refreshOrgs }) {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [localOrgs, setLocalOrgs] = useState([]); // Local org state
  const [loading, setLoading] = useState(true); // Add loading state

  const { userId } = useContext(UserContext);
  const { recentOrgs } = useContext(RecentContext);

  // Update localOrgs from context first; fallback to prop
  useEffect(() => {
    setLocalOrgs((recentOrgs && recentOrgs.length > 0 ? recentOrgs : orgs) || []);
  }, [recentOrgs, orgs]);

  useEffect(() => {
    setColumns([
      { name: 'name', align: 'left', width: '60%' },
      { name: 'type', align: 'left', width: '40%' },
    ]);

    const buildRows = async () => {
      setLoading(true); // Start loading
      try {
        const rowData = await Promise.all(
          localOrgs
            .sort((a, b) => {
              // Sort by creation date (newest first), fallback to timestamp
              const dateA = new Date(a.created_at || a.timestamp || 0);
              const dateB = new Date(b.created_at || b.timestamp || 0);
              return dateB - dateA;
            })
            .slice(0, 4)
            .map(async (org) => {
              const orgType = org.org_type || org.raw?.org_type || org.type || 'Unknown';

              return {
                name: (
                  <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
                    {org.name || org.raw?.name}
                  </ArgonTypography>
                ),
                type: (
                  <ArgonTypography variant="caption" color="text.secondary" fontWeight="regular">
                    {orgType}
                  </ArgonTypography>
                ),
              };
            })
        );
        setRows(rowData);
      } catch (error) {
        console.error('Error building rows:', error);
        // Optionally show an error message to the user here, e.g., using a state variable
      } finally {
        setLoading(false); // Stop loading, regardless of success/failure
      }
    };

    buildRows();
  }, [localOrgs, onEdit, userId, refreshOrgs]); // Include refreshOrgs in dependencies

  return (
    <ArgonBox mb={1} mt={2}>
      <ArgonBox
        sx={{
          '& .MuiTableRow-root:not(:last-child)': {
            '& td': {
              borderBottom: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <Table columns={columns} rows={rows} />
        )}
      </ArgonBox>
    </ArgonBox>
  );
}

export default RecentOrgs;
